import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';
import { CandidateReputationActions } from '@axiom/const';

export const ActionReputationDetailsSchema = z.object({
  action: z.enum(ZodArrayToEnum(Object.values(CandidateReputationActions))),
  actionNotes: z.string().nullable(),
});

export type ActionReputationDetailsType = z.infer<
  typeof ActionReputationDetailsSchema
>;
